import {SET_DATA_IMAGE_GALLERY} from "../../types";

export function setDataImageGallery(data) {
    return (dispatch) => {
        dispatch({type: SET_DATA_IMAGE_GALLERY, payload: data})
    }
}